import PropTypes from 'prop-types';

import {
    BlockListType,
    BlockType,
    PageType
} from 'SourceType/CMS.type';

export {
    BlockListType,
    BlockType,
    PageType
};

export const PageCardPropsType = PropTypes.shape({
    identifier: PropTypes.string,
    title: PropTypes.string,
    content_image: PropTypes.string,
    page_type: PropTypes.string,
    limitation_customer_group_ids: PropTypes.arrayOf(PropTypes.number),
    featured_customer_group_ids: PropTypes.arrayOf(PropTypes.number),
    content_video: PropTypes.string,
    tag_label: PropTypes.string,
    category: PropTypes.shape({
        name: PropTypes.string,
        uid: PropTypes.string
    })
});

export const InstagramPostType = PropTypes.shape({
    media_type: PropTypes.string,
    caption: PropTypes.string,
    media_url: PropTypes.string,
    permalink: PropTypes.string,
    thumbnail_url: PropTypes.string,
    timestamp: PropTypes.string
});

export const PromoBannerType = PropTypes.shape({
    additional_block_html: PropTypes.string,
    auto_close_time: PropTypes.string,
    background_color: PropTypes.string,
    banner_id: PropTypes.number,
    banner_image: PropTypes.string,
    banner_image_desktop: PropTypes.string,
    banner_image_desktop_secondary: PropTypes.string,
    category: PropTypes.string,
    cms_block_id: PropTypes.number,
    content_position: PropTypes.string,
    cta_color: PropTypes.string,
    cta_label: PropTypes.string,
    description: PropTypes.string,
    floating_image: PropTypes.string,
    floating_position: PropTypes.string,
    fullwidth: PropTypes.bool,
    gradient: PropTypes.bool,
    name: PropTypes.string,
    page: PropTypes.number,
    page_type: PropTypes.string,
    popup_image: PropTypes.string,
    popup_responsive: PropTypes.string,
    priority: PropTypes.number,
    sku: PropTypes.string,
    title: PropTypes.string,
    title_color: PropTypes.string,
    title_color_desktop: PropTypes.string,
    title_shadow: PropTypes.bool,
    type: PropTypes.string,
    url: PropTypes.string,
    youtube_key: PropTypes.string,
    youtube_mobile_key: PropTypes.string,
    content: PropTypes.string
});
